export const level = [
  {
    value: 1,
    label: "All Level"
  },
  {
    value: 2,
    label: "Beginner"
  },
  {
    value: 3,
    label: "Intermediate"
  },
  {
    value: 4,
    label: "Expert"
  }
];

export const levelObj = {
  1: "All Level",
  2: "Beginner",
  3: "Intermediate",
  4: "Expert"
};
